import React from "react";
import { Link } from "react-router-dom";

const ServiceCard = ({
  title,
  image,
  link,
}: {
  title: string;
  image: string;
  link: string;
}) => {
  return (
    <div className="relative h-64 rounded-lg overflow-hidden shadow-lg">
      <img
        src={image}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center p-4">
        <h3 className="text-white text-xl font-bold mb-4">{title}</h3>
        <Link
          to={link}
          className="px-6 py-2 rounded-md transition-all duration-300 bg-blue-900 text-white hover:bg-blue-800"
        >
          Contáctanos
        </Link>
      </div>
    </div>
  );
};

const Services: React.FC = () => {
  const services = [
    {
      title: "Sistema Interamericano de Derechos Humanos",
      image: "/images/servicios/1.png",
      link: "/contacto",
    },
    {
      title: "Derecho Constitucional",
      image: "/images/servicios/2.png",
      link: "/contacto",
    },
    {
      title: "Derecho Penal",
      image: "/images/servicios/3.png",
      link: "/contacto",
    },
    {
      title: "Derecho Privado",
      image: "/images/servicios/4 (1).png",
      link: "/contacto",
    },
    {
      title: "Derecho Disciplinario",
      image: "/images/servicios/5.png",
      link: "/contacto",
    },
    {
      title: "Derecho Público",
      image: "/images/servicios/6.png",
      link: "/contacto",
    },
    {
      title: "Derecho Laboral",
      image: "/images/servicios/7.png",
      link: "/contacto",
    },
    {
      title: "Reclamos Administrativos",
      image: "/images/servicios/8.png",
      link: "/contacto",
    },
    {
      title: "Derecho Contravencional",
      image: "/images/servicios/9.png",
      link: "/contacto",
    },
  ];

  return (
    <div className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Áreas de Práctica</h1>
          <p className="text-gray-600 max-w-3xl mx-auto">
            Nuestra firma de abogados se enorgullece de ofrecer servicios
            legales excepcionales y personalizados a las personas que requieren
            de apoyo jurídico. Reconocemos la importancia de comprender las
            necesidades y dinámicas específicas de nuestra comunidad local, y
            nos comprometemos a brindar soluciones legales efectivas que
            reflejen este entendimiento profundo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              title={service.title}
              image={service.image}
              link={service.link}
            />
          ))}
        </div>

        <div className="mt-16 text-center">
          <Link
            to="/contacto"
            className="px-6 py-2 rounded-md transition-all duration-300 bg-blue-900 text-white hover:bg-blue-800 text-lg"
          >
            Consulta Gratis
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Services;
